/**
 * useWorkingClaimEdited
 *
 * Reactive read of the session-scoped working-billing-claim edit tracker.
 * `true` once the provider has edited this encounter's claim in this session.
 *
 * Accepting the model's suggestion is NOT an edit and does not set this — see
 * `useWorkingClaimWritten` for the broader "was it written at all?" predicate.
 *
 * See `utils/workingClaimEditTracker` for why this exists (GDN-2614 / U3).
 */

import { useCallback, useSyncExternalStore } from 'react';

import {
  hasWorkingClaimEdit,
  subscribeToWorkingClaimEdits,
} from '../utils/workingClaimEditTracker';

export function useWorkingClaimEdited(encounterId: string | null | undefined): boolean {
  const getSnapshot = useCallback(() => hasWorkingClaimEdit(encounterId), [encounterId]);
  // Server snapshot: never suppress during SSR/hydration.
  const getServerSnapshot = useCallback(() => false, []);

  return useSyncExternalStore(subscribeToWorkingClaimEdits, getSnapshot, getServerSnapshot);
}
